import LoginAsToolContainer from './LoginAsToolContainer';

export default LoginAsToolContainer;
